jQuery(function ($) {

  // Responsive video embed
  function responsiveContainer() {

    var $allVideos = $(
      "iframe[data-src*='youtube.com'], iframe[src*='player.vimeo.com']"
    );

    $allVideos.each(function () {
      $(this).wrap("<div class='responsive-container'></div>");
    });
  }

  // MOBILE MENU ICON TOGGLE
  $(".hamburger").on("click", function () {
    $(this).toggleClass("is-active");
  });

  // Toggle content icon
  $(".toggle-content-link").on("click", function () {
    $(this).find("i").toggleClass("fa-chevron-down fa-chevron-up");
  });

  $('.toggle-content').on('click', function () {

    let row = $(this).data('row');
    let container_class = '.toggle-content-' + row + ' .toggle-content-container';
    $(this).toggleClass('collapsed');

    $(container_class).toggle();

  });

  // Sidebar nav-menu
    $(".sidebar-menu .children .page_item_has_children").prepend(
      '<button class="sub-menu-btn" aria-label="avaa ja sulje sivuvalikko"><i class="fa fa-plus"></i></button>'
    );


    $("#sidebar-menu .current_page_parent > .children").addClass("open");
    $("#sidebar-menu .current_page_ancestor > .children").addClass("open");
    $("#sidebar-menu .children .current_page_item > .children").addClass("open");

    $(".sub-menu-btn").each(function() {
      var children = $(this).siblings(".children");
      if (children.hasClass("open")) {
          $(this).find("i").toggleClass("fa fa-minus fa fa-plus");
      }
  });



    $(".sub-menu-btn").click(function () {
      if ($(this).siblings(".children").hasClass("open")) {
        $(this).siblings(".children").removeClass("open");
        $(this).find("i").toggleClass("fa fa-minus fa fa-plus");
        $(this).attr("aria-expanded", "false");
      } else {
        $(this).siblings(".children").addClass("open");
        $(this).find("i").toggleClass("fa fa-plus fa fa-minus");
        $(this).attr("aria-expanded", "true");
      }
    });

    $("#sidebar-menu-mobile").on("click keydown", function () {
      $(this).find("i").toggleClass("fa-plus fa-minus");
      $(".sidebar-menu").slideToggle(500);
    });

  // Accessbility tools: Toggle contrast
  $("#page").toggleClass(window.localStorage.toggled);

  $("#contrast, #contrast--mobile").on("click", function(event) {

    event.preventDefault();

    if (window.localStorage.toggled != "high-contrast") {
      $("#page").toggleClass("high-contrast", true);
      window.localStorage.toggled = "high-contrast";
    } else {
      $("#page").toggleClass("high-contrast", false);
      window.localStorage.toggled = "";
    }
  });

  // Accessbility tools: Toggle text size
  $("#text-ui").toggleClass(window.sessionStorage.toggled);

  $("#font-size, #font-size--mobile").on("click", function(event) {

    event.preventDefault();

    if (window.sessionStorage.toggled != "bigger-font-size") {
      $("#text-ui").toggleClass("bigger-font-size", true);
      window.sessionStorage.toggled = "bigger-font-size";
    } else {
      $("#text-ui").toggleClass("bigger-font-size", false);
      window.sessionStorage.toggled = "";
    }
  });

  $('.woocommerce-product-gallery__image').on('click', function(e) {

    $('.woocommerce-product-gallery__trigger').trigger('click');

  });

  // Lightbox
  $(document).on('click', '[data-toggle="lightbox"]', function(event) {
    event.preventDefault();
    $(this).ekkoLightbox();
  });

  // Search bar
  $('#search-button').on('click', function (e) {

    e.preventDefault();

    if ( $('#search-container').is(':visible') ) {

      // ...

    } else {

      $('#search-container').show();

    }

  });

  // & mobile
  $('#search-btn-mobile').on('click', function() {

    e.preventDefault();

    if ( $('#search-container').is(':visible') ) {

      // ...

    } else {

      $('#search-container').show();

    }

  });

  let contents = $(".top1-navigation-inner").clone();
  $('<li />', {html: contents}).appendTo('#mega-menu-primary').addClass('mobile-only');

  $('.crue-ukk-item').on('click', function() {
    $(this).children('.crue-ukk-vastaus').toggle();
  });

  $('.crue-single-longer-product-description-container .crue-read-more').on('click', function(e) {
    e.preventDefault();
    $(this).siblings('.crue-single-longer-product-description').toggle();
  });

  $('.crue-single-ravintosisalto-container .crue-read-more').on('click', function(e) {
    e.preventDefault();
    $(this).siblings('.crue-single-ravintosisalto').toggle();
  });

  // Close search bar on outside click
  $(document).mouseup( function (e) {

    var container = $('#search-container');

    if (container.is(':visible') && !container.is(e.target) && container.has(e.target).length === 0) {

      $('#search-container').hide();

    }

  });

  // Häiriötiedotteet

  function closeBanner() {

    // If banner should be hidden
    if (window.sessionStorage.getItem('hide_banner')) {
      $("#alert-banner").addClass('d-none');
    } else {
      $("#alert-banner").removeClass('d-none').addClass('d-block');
    }

    // Handle close button
    $("#close-banner").on('click', function() {
      window.sessionStorage.setItem('hide_banner', 'true');
      $("#alert-banner").removeClass('d-block').addClass('d-none');
    });

  }

  // Init
  closeBanner();


  // Init
  responsiveContainer();
});
